/**
 * Checkout y pago (epica PAG).
 */
import type { CrearPedidoDto, RespuestaConfirmacionPedido, RespuestaInicioPago } from '@bandu/compartido';

import { pedir } from './cliente-api';

export function crearPedido(datos: CrearPedidoDto): Promise<RespuestaInicioPago> {
  return pedir<RespuestaInicioPago>('/pedidos', { metodo: 'POST', cuerpo: datos });
}

/**
 * El resultado del pago. Con el token de la transaccion —el que Webpay le dejo
 * a este navegador al volver— la respuesta trae ademas el comprobante que
 * exige Transbank (PAG-04); sin el, solo la referencia y el total.
 */
export function obtenerConfirmacionPedido(
  referencia: string,
  token: string | null,
  senal?: AbortSignal,
): Promise<RespuestaConfirmacionPedido> {
  const consulta = token === null ? '' : `?token=${encodeURIComponent(token)}`;

  return pedir<RespuestaConfirmacionPedido>(
    `/pedidos/${encodeURIComponent(referencia)}${consulta}`,
    { ...(senal ? { senal } : {}) },
  );
}
